const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';
const Tabs = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domTabsBlockWrap: $('.js-product-resources__tabs'),
	$domTabsBlockBox: $('.js-product-resources__tabs-boxes'),
	$domTabsBlockBtn: $('.js-product-resources__tabs-btn'),
	$domBuildSectionWrap: $('.js-build-section__tabs'),
	$domBuildSectionBox: $('.js-build-section__tabs-boxes'),
	$domBuildSectionBtn: $('.js-build-section__tabs-btn'),
	$domTabs: $('.js-tab'),
	$domTabsBtn: $('.js-tabs-btn'),
	classActive: 'is-active',

	/** @description Initialize */
	init: function() {
		this.tabsTabsBlock();
		this.tabsBuildSection();
		this.tabsSection();
		this.autoSelectBuildSectionTab();
	},

	autoSelectBuildSectionTab: function() {
		const params = new URLSearchParams(window.location.search);
		const taxonomy = params.get('tab');

		if (!taxonomy) {
			return;
		}

		const $targetBtn = Tabs.$domBuildSectionBtn.filter(
			`[data-taxonomy="${taxonomy}"]`
		);

		if ($targetBtn.length) {
			$targetBtn.siblings(Tabs.$domBuildSectionBtn).removeClass(Tabs.classActive);
			$targetBtn.addClass(Tabs.classActive);

			const index = $targetBtn.index();
			const $scope = $targetBtn.closest('.js-build-section__tabs');
			const $boxes = $scope.find(Tabs.$domBuildSectionBox);

			$boxes.hide();
			$boxes.eq(index).show();
		}
	},

	/** @description Smooth scroll helper to Build Section top */
	/* scrollToBuildSection: function() {
		const $wrap = Tabs.$domBuildSectionWrap.first();
		if (!$wrap.length) return;

		$('html, body').stop(true).animate({
			scrollTop: $wrap.offset().top -150
		}, 600);
	}, */

	tabsTabsBlock: function() {
		Tabs.$domTabsBlockBtn.on('click', function(e) {
			e.preventDefault();
			$(this).siblings(Tabs.$domTabsBlockBtn).removeClass(Tabs.classActive);
			$(this).addClass(Tabs.classActive);
			const index = $(this).index();
			$(this).parent().parent().parent().find(Tabs.$domTabsBlockBox).hide();
			$(this).parent().parent().parent().children().find(Tabs.$domTabsBlockBox).eq(index).fadeIn('slow');
			/* if (window.innerWidth < 768) {
				$('html, body').animate({
					scrollTop: Tabs.$domTabsBlockWrap.offset().top -150
				}, 1000);
			} */
		});
	},
	tabsBuildSection: function() {
		Tabs.$domBuildSectionBtn.on('click', function(e) {
			e.preventDefault();

			$(this).siblings(Tabs.$domBuildSectionBtn).removeClass(Tabs.classActive);
			$(this).addClass(Tabs.classActive);

			const index = $(this).index();
			const $scope = $(this).closest('.js-build-section__tabs');
			const $boxes = $scope.find(Tabs.$domBuildSectionBox);
			// const $title = document.querySelector('.build-section__tabs');
			const $title = $scope[0];
			// Hide all panels, then show the targeted one
			$boxes.hide();
			const $panel = $boxes.eq(index).show();

			// If the panel contains a slider
			if ($panel.find('.js-product-more-like-slider').length) {
				// Wait one animation frame so the element is actually visible, then call setPosition
				requestAnimationFrame(() => {
					$panel.find('.js-product-more-like-slider.slick-initialized').slick('setPosition');
				});
			}

			if ($title) {
				const offset = 250;
				const top = $title.getBoundingClientRect().top + window.scrollY - offset;

				window.scrollTo({
					top: top,
					behavior: 'smooth'
				});
			}
		});
	},
	tabsSection: function() {
		Tabs.$domTabsBtn.on('click', function(e) {
			e.preventDefault();
			$(this).siblings(Tabs.$domTabsBtn).removeClass(Tabs.classActive);
			$(this).addClass(Tabs.classActive);
			const index = $(this).index();
			$(this).parent().parent().parent().find(Tabs.$domTabs).hide();
			$(this).parent().parent().parent().children().find(Tabs.$domTabs).eq(index).fadeIn('slow');
		});
	},
};

export default Tabs;
